import Cookies from 'browser-cookies';
import genUuid from 'uuid';

const ClientUuidKey = 'clientUuid';

export const getUuid = () => {
  return Cookies.get(ClientUuidKey);
}

export const generateUuid = () => {
  const uuid = genUuid();
  Cookies.set(ClientUuidKey, uuid);
  return uuid;
}



// WEBPACK FOOTER //
// ./src/utils/client.js